import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IVivaApiKeyField {
	settingsId: string;
	onChange: (value: string) => void;
}

const VivaApiKeyField: React.FC<IVivaApiKeyField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAPIKey') }], [t]);

	return (
		<FormInput
			testId="VivaApiKeyField"
			name={`vivaApiKey-${settingsId}`}
			label="APIKeyLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(VivaApiKeyField);
